// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609251834/js/" + chunkId + "." + {"44":"958951a9","225":"23093393","481":"8b37afe8","486":"eaded68a","770":"c39ac75d"}[chunkId] + ".0.39706600185811236.chunk.js";
};